<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <!-- początek strony drukowania -->
          <div id="print-section">
          <div class="table-responsive">
            <table class="table table-bordernone table-striped">
              <thead>
                <tr>
                  <th>
                    <img src="../../../../assets/images/logo/logo-inniver.png" alt="logo" height="40">
                  </th>
                  <th class="text-right" style="vertical-align: middle">
                    <h5>{{invoiceData.invoiceNumber}}</h5>
                  </th>
                </tr>
              </thead>
            </table>
          </div>

          <br>
          <br>
          <h2 class="text-center f-w-700">INVOICE</h2>
          <br>

            <table style="width:100%">
              <thead>
                <tr>
                  <th style="width:25%">
                    <h5>Client:</h5>
                  </th>
                  <th style="width:50%">
                  </th>
                  <th style="width:25%">
                    <h5>Payment Details:</h5>
                  </th>
                </tr>
                <tr>
                  <td style="vertical-align: top; background-color: #e6e6e6; border: 1px; border-radius: 10px; padding: 15px;">
                    {{invoiceData.publisher.firstName}} {{invoiceData.publisher.lastName}}<br>
                    <span *ngIf="invoiceData.publisher.company!=''">{{invoiceData.publisher.company}}<br></span>
                    <span *ngIf="invoiceData.publisher.tax!=''">{{invoiceData.publisher.tax}}<br></span>
                    <span *ngIf="invoiceData.publisher.address!=''">{{invoiceData.publisher.address}}<br></span>
                    {{invoiceData.publisher.city}}, {{invoiceData.publisher.zipCode}}<br>
                    {{invoiceData.publisher.country.name}}<br><br>
                    <span class="f-w-700">e-mail: {{invoiceData.publisher.email}}</span>
                  </td>
                  <td></td>
                  <td style="vertical-align:top">
                    payment method: <span class="f-w-700">{{invoiceData.payoutMethod.name}}</span><br>
                    <span *ngIf="invoiceData.payoutMethod.name=='Payoneer'">email: {{invoiceData.payoutMethodDetails.email}}</span>
                    <span *ngIf="invoiceData.payoutMethod.name=='PayPal'">email: {{invoiceData.payoutMethodDetails.email}}</span>
                    <span *ngIf="invoiceData.payoutMethod.name=='Wire'">
                    account holder: {{invoiceData.payoutMethodDetails.accountHolder}}<br>
                    Bank name: {{invoiceData.payoutMethodDetails.bankName}}<br>
                    IBAN: {{invoiceData.payoutMethodDetails.iban}}<br>
                    SWIFT: {{invoiceData.payoutMethodDetails.swift}}<br>
                    Country: {{invoiceData.payoutMethodDetails.bankCountry.name}}
                    </span>
                  </td>
                </tr>
              </thead>
            </table>

          <br>
          <br>

          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th class="text-center" style="vertical-align: top; width:5%">#</th>
                  <th class="text-center" style="width:15%">Item</th>
                  <th class="text-center" style="width:20%">Description</th>
                  <th class="text-center" style="width:20%">Amount</th>
                  <th class="text-center" style="width:20%">Payment fee</th>
                  <th class="text-center" style="width:20%">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-center" scope="row">1</th>
                  <td class="text-center">{{invoiceData.paymentTerm.name}}</td>
                  <td class="text-center">Cyclical payment of collected conversions</td>
                  <td class="text-center">{{invoiceData.amount | currency}}</td>
                  <td class="text-center">{{invoiceData.payoutMethodDetails.paymentFeeForEachRequest | currency}}</td>
                  <td class="text-center">{{invoiceData.amount - invoiceData.payoutMethodDetails.paymentFeeForEachRequest | currency}}</td>
                </tr>
                <tr>
                  <th colspan="5"></th>
                  <th class="text-center">Total: {{invoiceData.amount - invoiceData.payoutMethodDetails.paymentFeeForEachRequest | currency}}</th>
                </tr>
              </tbody>
            </table>
          </div>

          <br>
          </div>
          <!-- koniec strony drukowania -->
          <div class="btn-showcase">
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="accept payment" (click)="onPay()">
              Pay</button>
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="revert payment to Publisher" (click)="onRevert()">
              Revert</button>
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="print invoice" [useExistingCss]="true" printSectionId="print-section" ngxPrint>
              Print</button>
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="return to all payments" (click)="onCancel()">
              Cancel</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
